import { useWebSocket } from "../components/hooks/useWebSocket";
import { useEffect, useState } from "react";
import ButtonLoader from "../components/Widgets/ButtonLoader";
import DSDialog from "./system-design/DSDialog";
import DSDialogTitle from "./system-design/DSDialogTitle";
import DSDialogContent from "./system-design/DSDialogContent";
import DSBox from "./system-design/DSBox";
import DSStack from "./system-design/DSStack";
import DSTextField from "./system-design/DSTextField";
import DSTypography from "./system-design/DSTypography";
import DSSecondaryButton from "./system-design/DSSecondaryButton";
import useDeviceType from "../components/hooks/useDeviceType";

interface LogcatStreamModalProps {
  deviceId: string;
  onClose: () => void;
}

const FilterLog = ({ onFilter }: { onFilter: (text: string) => void }) => {
  const [text, setText] = useState<string>();
  return (
    <form noValidate style={{ display: "flex", flexDirection: "column" }}>
      <DSStack
        direction="row"
        spacing={1}
        sx={{ justifyContent: "flex-end", alignItems: "center" }}
      >
        <DSTextField
          value={text}
          placeholder="Enter text to filter"
          required
          size="small"
          fullWidth
          onChange={(e) => {
            setText(e.target.value);
          }}
          type="text"
        />

        <ButtonLoader
          title="filter"
          disabled={!text}
          style={{ fontSize: "12px", width: "50%" }}
          onClick={async () => {
            onFilter(text!);
            setText("");
          }}
        ></ButtonLoader>
      </DSStack>
    </form>
  );
};

const LogcatStreamModal: React.FC<LogcatStreamModalProps> = ({
  deviceId,
  onClose,
}) => {
  const uri = "wss://clock-socket-917257785826.us-central1.run.app/";
  const {
    start,
    stop,
    sendCommand,
    isConnected,
    isReady,
    loadingMessage,
    logElement,
    clearLog,
  } = useWebSocket({ uri, devId: deviceId });

  const { isSmallTablet } = useDeviceType();

  useEffect(() => {
    start();
  }, []);

  const handleClear = () => {
    sendCommand("clear");
    clearLog();
  };

  const handleRead = () => {
    sendCommand("start");
  };

  const handleStop = () => {
    stop();
    onClose();
  };

  return (
    <DSDialog
      open
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      fullScreen={isSmallTablet}
    >
      <DSDialogTitle>Logcat Stream</DSDialogTitle>
      <DSDialogContent>
        <DSBox sx={{ textAlign: "center", mb: 2 }}>
          <DSStack
            direction="row"
            spacing={1}
            sx={{ justifyContent: "center", mb: 1 }}
          >
            <DSSecondaryButton onClick={handleRead} disabled={!isReady}>
              Read
            </DSSecondaryButton>
            <DSSecondaryButton
              onClick={() => sendCommand("pause")}
              disabled={!logElement}
            >
              Pause
            </DSSecondaryButton>
            <DSSecondaryButton onClick={handleClear} disabled={!logElement}>
              Clear
            </DSSecondaryButton>
            <DSSecondaryButton onClick={handleStop} disabled={!isConnected}>
              Stop
            </DSSecondaryButton>
          </DSStack>
          <FilterLog onFilter={(text) => sendCommand(text)} />
        </DSBox>

        <DSBox
          id="log"
          ref={logElement}
          sx={{
            overflowY: "auto",
            p: 2,
            height: "60vh",
            backgroundColor: "#161616",
            color: "#00ff00",
            fontFamily: "monospace",
            borderRadius: 2,
          }}
        >
          {loadingMessage ? (
            <DSTypography>{loadingMessage}</DSTypography>
          ) : null}
        </DSBox>
      </DSDialogContent>
    </DSDialog>
  );
};

export default LogcatStreamModal;
